import React from 'react'
import { Button, Loader } from 'semantic-ui-react'

// TODO for Kamil
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormButtonWithStatus = ({ content, form, ...props }: any) => {
  if (form.submitting) {
    // can't use Button's `loading` prop because our custom styles mess it up
    content = <Loader active inline="centered" size="small" />
  } else if (form.dirty === false) {
    content = <i className="check icon large" />
  }
  // set min-height so the button height does not change when showing the Loader
  return <Button fluid primary size="large" content={content} style={{ minHeight: 56 }} {...props} />
}
